import BaseStore from "@/lib/StoreBase";

export default class Marketplace extends BaseStore {
  url_base = 'https://novasector.net/v1/'

  pop_list = []


  constructor() {
    super();

    this.currentSet.line_cnt = 1
    // change to development env if needed
    if (process.env.NODE_ENV === 'development')
      this.url_base = '/v1/'

    const list = this.fetch_list()
    list.then((xList) => {
      console.log('xList:', xList)
      this.pop_list = xList
    } )
  }

  roll(population) {

    return this.mp_fetch(population)

    // return (pkg) => {
    //
    //   // copy values from pkg to the current jewel set
    //   this.currentSet.list = pkg.list
    //
    //   // jewel_results is a secondary, non reactive,
    //   // copy of the results to be stored in special item history
    //   const si_results = {}
    //   // now assign results values to backup/history obj
    //   Object.assign(si_results, pkg)
    //
    //   // add to history buffer
    //   this.history.push(si_results)
    //   this.cur_rec = this.history.length
    //   this.tot_rec += 1
    //
    //   this.determineMaxWidth()
    //   this.determine_columns()
    // }
  }



  async fetch_list() {

    const url = this.url_base + 'marketplace/poplist/'
    const res = await fetch(url,{
      method: "GET"
    })
    console.log('fetch list:', res)
    return res.json()
  }

  async cvt_search(name) {
    const url = this.url_base + 'marketplace/search/' + name
    const response = await fetch(url, {
      method: "GET"
    })

    return await response.json()
  }

  async add_population(city, population) {
    const url = this.url_base + 'marketplace/addpop'

    console.log('[Marketplace > add_population]')
    console.log('           city:', city)
    console.log('           pop :', population)
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        city: city,
        population: population
      }),
    })
    return response
  }

  async mp_fetch(pop) {
    const url = this.url_base + 'marketplace/' + pop
    const res = await fetch(url)
    return res.json()
  }


  determineMaxWidth() {

  }

  determine_columns() {
  }

}

